import axios from 'axios';
import qs from 'qs';
import { Dialog, Toast } from 'vant';
import route from '../router/index';

let instance = axios.create({
    timeout: 30000,
    baseURL: process.env.NODE_ENV === "development" ? '/api' : "/"
});

instance.interceptors.request.use((config) => {

    config.params && !config.params.hideLoading && Toast.loading({ mask: true, duration: 0 });
    if (config.method === 'post' || config.method === 'put') {
        config.data = qs.stringify(config.data);
    }
    if (!config.headers.Authorization) {
        config.headers.Authorization = 'Bearer ' + (window.localStorage.getItem('Authorization') || '');
    }
    var sbzRegion = localStorage.getItem('sbzRegion');
    if (sbzRegion) {
        sbzRegion = JSON.parse(sbzRegion);
        config.headers['SBZ-REGION'] = sbzRegion.value;
    }
    var company = localStorage.getItem('company');
    if (company) {
        config.headers['Company'] = company;
    }

    var storeId = localStorage.getItem('storeId');
    if (storeId) {
        config.headers['STORE-ID'] = storeId;
    }

    if (window.__wxjs_environment === "miniprogram") {
        config.headers['PAGE-TYPE'] = 'miniprogram';
    } else {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            config.headers['PAGE-TYPE'] = 'wx';

        } else {
            config.headers['PAGE-TYPE'] = 'h5';
        }

    }
    return config;
}, (err) => {
    return Promise.reject(err);
});

instance.interceptors.response.use((res) => {
    Toast.clear();
    // if (!res.data.success) {
    // 	switch (res.data.code) {
    // 		case 422:
    // 			var flag = Array.isArray(res.data.data) && res.data.data.length;
    // 			Dialog.alert({message: flag ? res.data.data[0].message : res.data.message})
    // 			break;
    //     case 401:
    // 			break;
    // 		case 404:
    // 			break;
    // 	}
    // 	return Promise.resolve(res);
    // }
    let data = res.data;
    if (!data.success) {
        if (data.error) {
            Dialog.alert({
                title: '警告',
                // message: data.error.code + ':' + data.error.message
                message: data.error.message
            });
        }
        // return res;
        let err;
        if (data.err) {
            err = new Error(data.err.message);
        } else if (data.error) {
            return Promise.reject(data.error.message);
        } else {
            err = new Error('服务器跑路了...');
        }
        err.response = data;
        return Promise.reject(err);
    }
    return res;
}, (error) => {
    if (error.response && error.response.status == 401) {
        Toast.clear();
        if (route.currentRoute.name == 'login') {
            return
        }
        route.replace({
            path: '/login',
            query: { redirect: route.currentRoute.fullPath }
        })
        return Promise.reject(error);
    } else {
        Toast.clear();
        Dialog.alert({
            title: '警告',
            message: error.response.data.error.message
        }).then(() => {
            if (error.response.data.error.message === '当前团购不属于你所属公司区域') {
                route.back()
            } else if (route.currentRoute.name != 'placeOrderEntity') {
                location.reload();
            } else {
                if (route.history.current.query.type === 'group') {
                    route.back()
                } else {
                    route.replace({
                        path: '/order',
                    })
                }

            }
        });

    }
    return Promise.reject(error);
});

const post = (url, data, config = {}) => {
    return instance.post(url, data, config)
}

const put = (url, data, config = {}) => {
    return instance.put(url, data, config)
}

const get = (url, params, config = {}) => {
    return instance.get(url, {
        params: params,
        ...config
    })
}

const deleteMethod = (url, config = {}) => {
    return instance({
        url: url,
        method: 'delete',
        ...config
    })
}
export {
    get
}
export default {
    install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $reqGet: {
                value: get
            },
            $reqPost: {
                value: post
            },
            $reqPut: {
                value: put
            },
            $reqDel: {
                value: deleteMethod
            },
        })
    }
}